import { showDialog } from '../reducers/app';
import { setupEditPanelTransmitterDialog } from '../reducers/edit_panel_transmitter_dialog';
export function editPanelDevice(id) {
    return (dispatch, getState) => {
        const { definitions } = getState();
        const t = definitions.panel_devices.entities[id];
        if (t == undefined)
            return;
        const pg = definitions.panel_groups.entities[t.panel_group_id];
        if (pg == undefined)
            return;
        dispatch(setupEditPanelTransmitterDialog({
            panel_device_id: t.id,
            device_id: t.device_id,
            panel_group_id: t.panel_group_id,
            ord: t.ord
        }));
        dispatch(showDialog('edit-panel-transmitter'));
    };
}
